import React from 'react';

import PropTypes from 'prop-types';

import { Box } from '@adsk/alloy-react-box';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { Spec } from '../../types';

interface SpecCellProps {
  spec: Spec;
}

const SpecCell: React.FC<SpecCellProps> = ({ spec }) => {
  const { identifier, title } = spec;

  return (
    <Box width="100%">
      <Box typography="ellipsis">{identifier}</Box>
      <Box typography="ellipsis" color="charcoal700" width="100%">
        <OverflowTooltip>{title}</OverflowTooltip>
      </Box>
    </Box>
  );
};

SpecCell.displayName = 'SubmittalsSpecCell';
SpecCell.propTypes = {
  spec: PropTypes.shape({
    id: PropTypes.string.isRequired,
    identifier: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default SpecCell;
